const actions = {
  FETCH_FORM_FOR_WORKSPACE_REQUEST: 'FETCH_FORM_FOR_WORKSPACE_REQUEST',
  FETCH_REQUEST_LOCATIONS: 'FETCH_REQUEST_LOCATIONS',
  FETCH_REQUEST_WORKSPACE: 'FETCH_REQUEST_WORKSPACE',
  FETCH_REQUEST_WORKSPACES: 'FETCH_REQUEST_WORKSPACES',
  FETCH_WORKSPACE_FORM_FOR_REQUEST: 'FETCH_WORKSPACE_FORM_FOR_REQUEST',
  SHOW_FORM_FOR_WORKSPACE_REQUEST: 'SHOW_FORM_FOR_WORKSPACE_REQUEST',
  SHOW_REQUEST_WORKSPACE: 'SHOW_REQUEST_WORKSPACE',
  SHOW_REQUEST_LOCATIONS: 'SHOW_REQUEST_LOCATIONS',
  SHOW_REQUEST_LOCATIONS_ERROR: 'SHOW_REQUEST_LOCATIONS_ERROR',
  SHOW_REQUEST_WORKSPACES: 'SHOW_REQUEST_WORKSPACES',
  SHOW_REQUEST_WORKSPACE_ERROR: 'SHOW_REQUEST_WORKSPACE_ERROR',
  SHOW_REQUEST_WORKSPACES_ERROR: 'SHOW_REQUEST_WORKSPACES_ERROR',
  SHOW_WORKSPACE_FORM_FOR_REQUEST: 'SHOW_WORKSPACE_FORM_FOR_REQUEST',
  TOGGLE_REQUEST_WORKSPACE_SELECTED: 'TOGGLE_REQUEST_WORKSPACE_SELECTED',
  TOGGLE_WORKSPACE_REQUEST: 'TOGGLE_WORKSPACE_REQUEST',
};

export const requestWorkspaceVerboseStates = {
  CHECKING: 'checking',
  ERROR: 'error',
  UNAVAILABLE: 'unavailable',
  FAIL: 'fail',
  MISSING: 'missing',
};

export const requestWorkspaceStates = {
  AVAILABLE: 'available',
  PENDING: 'pending',
  REFRESH: 'refresh',
  REQUESTED: 'requested',
  ...requestWorkspaceVerboseStates,
};

export const requestWorkspaceIcons = {
  [requestWorkspaceStates.AVAILABLE]: { icon: 'thumbs up outline', color: 'approved' },
  [requestWorkspaceStates.CHECKING]: { icon: 'circle notched', loading: true },
  [requestWorkspaceStates.ERROR]: { icon: 'times circle', color: 'error' },
  [requestWorkspaceStates.FAIL]: { icon: 'times circle', color: 'error' },
  [requestWorkspaceStates.MISSING]: { icon: 'times circle', color: 'error' },
  [requestWorkspaceStates.PENDING]: { icon: 'clock', color: 'pending' },
  [requestWorkspaceStates.REFRESH]: { icon: 'refresh' },
  [requestWorkspaceStates.REQUESTED]: { icon: 'clipboard list', color: 'pending' },
  [requestWorkspaceStates.UNAVAILABLE]: { icon: 'warning sign', color: 'error' },
};

export default actions;
